var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6417 8.63622L15.9557 2.06494C15.9557 5.60772 16.0128 5.83628 15.5557 6.86483C15.2022 7.66017 14.5545 8.60196 13.67 9.09335C10.5844 10.8076 7.49872 12.1218 5.09877 13.2647C4.23807 13.6745 3.55595 14.0075 3.04168 14.5789C2.00374 15.7322 1.93694 16.9789 2.07028 17.4932C0.516026 15.7561 0.070321 14.4075 0.0703246 13.9504C-0.386806 11.1504 1.49886 9.26477 2.6417 8.63622Z",
    fill: "#423ED8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6417 16.979L15.9557 10.4077C15.9557 13.9505 16.0128 14.1791 15.5557 15.2076C15.2022 16.0029 14.5545 16.9447 13.67 17.4361C10.5844 19.1504 7.49872 20.4646 5.09877 21.6075C4.23807 22.0173 3.55595 22.3503 3.04168 22.9217C2.00374 24.075 1.93694 25.3217 2.07028 25.8359C0.516026 24.0988 0.070321 22.7503 0.0703246 22.2932C-0.386806 19.4932 1.49886 17.6075 2.6417 16.979Z",
    fill: "#423ED8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2435 22.525C9.75551 22.2445 9.75551 21.5404 10.2435 21.2598L16.0003 17.9497L16.0003 25.8352L10.2435 22.525Z",
    fill: "#423ED8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65706 6.17897H1.99995V3.6076C1.45139 4.15616 0.438085 4.3314 0 4.35044V2.69334C0.342849 2.69334 0.872707 2.57906 1.3714 1.89336C1.87009 1.20766 1.94281 0.845762 1.99995 0.579102H3.65706C3.6761 0.769573 3.81705 1.29908 4.22847 1.89336C4.63989 2.48763 5.35226 2.67429 5.65701 2.69334V4.35044C4.91417 4.35044 3.88562 3.85522 3.65706 3.6076V6.17897Z",
    fill: "#423ED8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPurple);
export default __webpack_public_path__ + "static/media/logo_purple.e679a180d3332c35dc8d5cfa082fe5e0.svg";
export { ForwardRef as ReactComponent };